import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  // 类型
  getpileDateQuePage(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/pileDateQue/getPileDateQue', params)
  },
  editConf(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestDelete(apiPre + service.res + '/res/pileDateQue/deleteByid/' + params)
  },
  getStationIdAndStationName() {

    return http.requestGet(apiPre + service.res + '/res/station/getStationIdAndStationName')
  },
  getMeterAcquisitionTerminalByStationId(params) {

    return http.requestGet(apiPre + service.res +
      '/res/meterAcquisitionTerminal/getMeterAcquisitionTerminalByStationId/' + params)
  },
  getMeterBymeterAcquisitionTerminalid(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestGet(apiPre + service.res + '/res/meter/getMeterBymeterCodes/' + params)
  },
  getMeterAcquisitionTerminalByStationIds(params) {

    return http.requestGet(apiPre + service.res +
      '/res/meterAcquisitionTerminal/getMeterAcquisitionTerminalByStationIds/' + params)
  },
  exportpile(params) {
    return http.requestDownloadExcel(apiPre + service.res + '/res/pileDateQue/excelPile', params)
  },
  exportMeterLog(params) {
    return http.requestDownloadExcel(apiPre + service.res + '/res/pileDateQue/excelMeter', params)
  },
  meterFiltration(params){
    return http.requestGet(apiPre + service.res +'/res/meter/meterFiltration/'+params)
  }
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/pileDateQueManagerApi.js